class MediaController {
  constructor() {
    this.items = new Set();
  }

  register(mediaElement) {
    if (!mediaElement || this.items.has(mediaElement)) {
      return;
    }

    this.items.add(mediaElement);

    mediaElement.addEventListener('play', () => {
      this.pauseAll(mediaElement);
      mediaElement.closest('.post-media')?.classList.add('is-playing');
      mediaElement
        .closest('.post-media')
        ?.querySelector('[data-media-trigger]')
        ?.setAttribute('aria-label', mediaElement.tagName === 'AUDIO' ? 'توقف پادکست' : 'پخش ویدئو');
    });

    mediaElement.addEventListener('pause', () => {
      mediaElement.closest('.post-media')?.classList.remove('is-playing');
      mediaElement
        .closest('.post-media')
        ?.querySelector('[data-media-trigger]')
        ?.setAttribute('aria-label', mediaElement.tagName === 'AUDIO' ? 'پخش پادکست' : 'پخش ویدئو');
    });

    mediaElement.addEventListener('ended', () => {
      mediaElement.closest('.post-media')?.classList.remove('is-playing');
      mediaElement
        .closest('.post-media')
        ?.querySelector('[data-media-trigger]')
        ?.setAttribute('aria-label', mediaElement.tagName === 'AUDIO' ? 'پخش پادکست' : 'پخش ویدئو');
    });
  }

  pauseAll(except = null) {
    this.items.forEach((item) => {
      if (item !== except && !item.paused) {
        item.pause();
      }

      if (item !== except) {
        item.closest('.post-media')?.classList.remove('is-playing');
      }
    });
  }
}

export const mediaController = new MediaController();
